<div class="sale-search" #header>
  <div class="grid-container">
    <div class="header-background"></div>
    <div class="header-item">
      <h1 [attr.data-text]="'Bye Renting.'">Bye Renting.</h1>
      <h1 [attr.data-text]="'Buy Real Estate.'">Buy Real Estate.</h1>
    </div>
    <div class="picture-item">
      <img
        src="../../../assets/images/Map Webseite White.png"
        alt="Fixed Image"
        class="fixed-image" />
    </div>
    <div class="sale-objects">
      <div class="card-content">
        <scale-card
          class="search card-style"
          target="_blank"
          rel="noopener noreferrer"
          label="Filter">
          <div class="row row-style">
            <div class="search-autocomplete">
              <mat-form-field class="text-field" appearance="outline">
                <mat-label>Suche</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Ort, PLZ"
                  [matAutocomplete]="auto"
                  [formControl]="searchControl"
                  (keydown.enter)="onEnterPressed($event)" />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="onOptionSelected($event)">
                  <mat-option
                    *ngFor="let suggestion of filteredSuggestions | async"
                    [value]="suggestion">
                    <div class="suggestion-item">
                      <mat-icon>location_on</mat-icon>
                      <span>{{ suggestion.name }}</span>
                    </div>
                  </mat-option>
                  <mat-option
                    *ngIf="
                      (filteredSuggestions | async)?.length === 0 &&
                      searchControl.value
                    "
                    disabled>
                    <span>Keine Ergebnisse gefunden</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <app-custom-slider
              [value]="sliderValue"
              (valueChange)="setSliderValue($event)">
            </app-custom-slider>
            <div class="select">
              <mat-form-field class="text-field" appearance="outline">
                <mat-label>Gebäudeart</mat-label>
                <mat-select
                  [value]="selectedBuildingType"
                  (selectionChange)="onBuildingTypeChange($event)">
                  <mat-option value="Alle Gebäudearten"
                    >Alle Gebäudearten</mat-option
                  >
                  <mat-option
                    *ngFor="let building of buildingTypes"
                    [value]="building.id">
                    {{ building.buildingType }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="filter-actions-container">
            <su-button
              class="delete-container"
              [skin]="'secondary'"
              [disabled]="canDelete"
              (onClick)="resetFilter()"
              icon="trash"
              [label]="'Filter löschen' | translate">
              <mat-icon aria-label="Löschen">delete</mat-icon>
              <span> </span>
            </su-button>

            <div class="view-switcher">
              <button
                mat-icon-button
                (click)="setView('list')"
                aria-label="Listenansicht">
                <mat-icon [class.active-icon]="currentView === 'list'" class="sales-search-mat-icon"
                  >list</mat-icon
                >
              </button>
              <button
                mat-icon-button
                (click)="setView('grid')"
                aria-label="Kachelansicht">
                <mat-icon [class.active-icon]="currentView === 'grid'" class="sales-search-mat-icon"
                  >grid_view</mat-icon
                >
              </button>
            </div>
          </div>
        </scale-card>
      </div>
      <div class="app-sale-items-container" [ngClass]="{ loading: isLoading }">
        <div *ngIf="isLoading" class="loading-spinner">
          <scale-loading-spinner
            size="large"
            variant="white"
            alignment="vertical"
            text="Daten werden geladen..."
            class="sale-search-spinner"></scale-loading-spinner>
        </div>
        <div *ngIf="!isLoading">
          <app-sales-item
            [items]="tiles"
            [viewMode]="currentView"
            [pageIndex]="savedPage"
            (pageIndexChange)="savedPage = $event"
            (selectedItem)="onItemSelect($event)"></app-sales-item>
        </div>
      </div>
    </div>
  </div>

  <div class="sales-footer overview">
    <div class="info-text">
      Die Deutsche Telekom AG ist Eigentümerin des Grundstücks und der
      Immobilie. <br />Sie hat dieses Inserat/Angebot erstellt.
    </div>
  </div>
</div>
